<div
  data-bs-dismiss="offcanvas"
  class="btn btn-quaternary text-black cursor-pointer d-flex align-items-center justify-content-center"
  (click)="switchToGuardian()"
>
  <span class="material-symbols-outlined me-2">logout</span>
  {{ 'back.to.guardian' | translate }}
</div>
